import { NotificationStatusBar, type NotificationStatusBarItem } from '@today/ui-components'
import {
	type AppNotification,
	dismissNotification,
	runNotificationAction,
	useNotifications,
} from './notification-store'

/**
 * Routes an action press through the store, which guarantees it runs at most once (TO-644).
 * `runNotificationAction` dismisses first (its idempotency guard) and then runs the callback,
 * so the view's subsequent `onDismiss` for the same id is a harmless no-op.
 */
const toStatusBarItem = (notification: AppNotification): NotificationStatusBarItem =>
	notification.action
		? {
				...notification,
				action: { label: notification.action.label, onAction: () => runNotificationAction(notification.id) },
			}
		: notification

/** The app-wide notification status bar, bound to the notification store (TO-468). */
export function NotificationStatusBarContainer() {
	const notifications = useNotifications()
	return <NotificationStatusBar items={notifications.map(toStatusBarItem)} onDismiss={dismissNotification} />
}
